<div>
  <span *ngIf="showCaret" (click)="onToggleExpand($event)">
    <i *ngIf="!isExpanded" class="fa fa-angle-right"></i>
    <i *ngIf="isExpanded" class="fa fa-angle-down"></i>
  </span>
  <span>
    {{ params.value }}
  </span>
</div>
